import { DownloadAuthoringPdfMenuItem } from "authoring/routes/pdf/download-authoring-pdf-menu-item"

export function DownloadCustomerSideBySidePdf() {
    return (
        <DownloadAuthoringPdfMenuItem
            mode="side-by-side"
            audience="external"
            label="Download customer PDF: side-by-side"
            dataCy="download-customer-side-by-side-pdf-menu-item"
        />
    )
}
